module.exports = __webpack_public_path__ + "static/img/6.48ef132.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/zh/6.png
// module id = kxi1
// module chunks = 0